import React, { useState, useEffect } from 'react'; // FIX: Removed useCallback
import { useInView } from 'react-intersection-observer';

// --- 1. IMPORT LOCAL IMAGES (Using your specified images) ---
import image26 from '../../../assets/Images/Interior10.jpg';
import image17 from '../../../assets/Images/Interior27.jpg';
import image6 from '../../../assets/Images/Interior74.jpg';
import image34 from '../../../assets/Images/Interior65.jpg';
import image19 from '../../../assets/Images/Interior23.jpg';
import image30 from '../../../assets/Images/Interior111.jpg';
import image8 from '../../../assets/Images/Interior101.jpg';
import image25 from '../../../assets/Images/Interior6.jpg';
import image4 from '../../../assets/Images/Interior21.jpg';
import image32 from '../../../assets/Images/Interior97.jpg';


// --- Content for Interior Design (Image sources changed) ---
const vitals = [
    {
        image: image26, // Interior26.jpg
        icon: 'fas fa-drafting-compass',
        title: 'Smart Space Planning',
        description: 'Optimizing every square foot for maximum flow, function, and a feeling of spaciousness.',
    },
    {
        image: image17, // Interior17.jpg
        icon: 'fas fa-palette',
        title: 'Color & Material Mastery',
        description: 'Expertly curating color palettes and tactile materials that evoke the perfect mood and style.',
    },
    {
        image: image6, // Interior6.jpg
        icon: 'fas fa-lightbulb',
        title: 'Atmospheric Lighting',
        description: 'Designing layered lighting (ambient, task, accent) to transform a space and highlight its features.',
    },
    {
        image: image34, // Interior34.jpg
        icon: 'fas fa-couch',
        title: 'Custom Furnishings',
        description: 'Sourcing or designing bespoke furniture and cabinetry that fits your space and vision perfectly.',
    },
    {
        image: image19, // Interior19.jpg
        icon: 'fas fa-eye',
        title: 'Personalized Vision',
        description: 'We start by understanding your unique style to create a space that is truly and authentically yours.',
    },
    {
        image: image30, // Interior30.jpg
        icon: 'fas fa-leaf',
        title: 'Sustainable Sourcing',
        description: 'Prioritizing eco friendly, non toxic materials and sustainable practices whenever possible.',
    },
    {
        image: image8, // Interior8.jpg
        icon: 'fas fa-hammer',
        title: 'Quality Craftsmanship',
        description: 'A meticulous focus on high-quality craftsmanship and flawless finishing touches.',
    },
    {
        image: image25, // Interior25.jpg
        icon: 'fas fa-clipboard-check',
        title: 'Seamless Project Management',
        description: 'We handle all the logistics, from procurement to installation, so you can relax.',
    },
    {
        image: image4, // Interior4.jpg
        icon: 'fas fa-paint-brush',
        title: 'Curated Art & Decor',
        description: 'Selecting the final artwork and decor that bring personality and soul to your home.',
    },
    {
        image: image32, // Interior32.jpg
        icon: 'fas fa-receipt',
        title: 'Transparent Budgeting',
        description: 'Clear, honest communication about costs to ensure your vision aligns with your investment.',
    },
];

// Reusable Card component - Added onClick handler
const VitalCard = ({ vital, onImageClick }) => (
    <div className="w-full max-w-[320px] h-[400px] text-center bg-white border border-gray-100 rounded-2xl shadow-xl overflow-hidden cursor-pointer"
         style={{ transform: 'translateZ(0)' }}
         onClick={() => onImageClick(vital)} // Capture the click event here
    >
        
        {/* --- IMAGE CONTAINER --- */}
        <div className="h-[75%] w-full">
            <img 
                src={vital.image} 
                alt={vital.title} 
                className="w-full h-full object-cover transition-transform duration-500 hover:scale-[1.03]"
            />
        </div>
        
        {/* --- TEXT OVERLAY --- */}
        <div className="h-[25%] p-4 flex flex-col justify-center bg-white">
            <h3 className="text-lg font-bold text-gray-900 truncate">{vital.title}</h3>
        </div>
    </div>
);

// --- NEW MODAL COMPONENT (UPDATED ALIGNMENT) ---
const ImageModal = ({ image, onClose }) => {
    if (!image) return null;

    return (
        <div 
            // FIX: Changed items-start to items-center for vertical centering
            className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-90 backdrop-blur-sm transition-opacity duration-300 overflow-y-auto"
            onClick={onClose} 
        >
            <div 
                // Removed pt-16 since items-center will handle vertical spacing.
                // Keeping max-w-4xl and max-h-full for responsive sizing.
                className="relative p-2 max-w-4xl max-h-full pb-2" 
                onClick={(e) => e.stopPropagation()}
            >
                <button 
                    onClick={onClose} 
                    className="absolute z-[90] top-0 right-0 m-2 text-white text-3xl opacity-80 hover:opacity-100 transition sm:m-4" 
                    aria-label="Close modal"
                >
                    &times;
                </button>
                <img 
                    src={image.image} 
                    alt={image.title} 
                    // max-h-[75vh] ensures it doesn't get too large and still leaves room for caption.
                    className="max-w-full max-h-[75vh] w-auto h-auto rounded-lg shadow-2xl mx-auto" 
                />
                <p className="mt-3 text-center text-white text-lg font-semibold">{image.title}</p>
            </div>
        </div>
    );
};
// --- END MODAL COMPONENT ---


function CoreVitalsSection() {
    const { ref, inView } = useInView({ triggerOnce: true, threshold: 0.2 });
    
    // --- State for IMAGE MODAL ---
    const [selectedImage, setSelectedImage] = useState(null);

    // --- State for DESKTOP interactive fan ---
    const [activeIndex, setActiveIndex] = useState(Math.floor(vitals.length / 2));
    const [isHovered, setIsHovered] = useState(false);
    
    // --- State for MOBILE swipeable stack ---
    const [mobileActiveIndex, setMobileActiveIndex] = useState(0);
    const [touchStartX, setTouchStartX] = useState(0);
    const minSwipeDistance = 50;

    // Handler to open the modal
    const handleImageClick = (vital) => {
        setSelectedImage(vital);
    };

    // Handler to close the modal
    const handleCloseModal = () => {
        setSelectedImage(null);
    };

    // --- EFFECT: Stop main page scrolling when modal is open ---
    useEffect(() => {
        if (selectedImage) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = 'unset';
        }
        // Cleanup function
        return () => {
            document.body.style.overflow = 'unset';
        };
    }, [selectedImage]);

    // --- Handlers for DESKTOP ---
    const handleCardClick = (index) => {
        setActiveIndex(index);
    };
    const handleNextDesktop = () => {
        setActiveIndex((prevIndex) => (prevIndex + 1) % vitals.length);
    };
    const handlePrevDesktop = () => {
        setActiveIndex((prevIndex) => (prevIndex - 1 + vitals.length) % vitals.length);
    };

    // --- Handlers for MOBILE (swipe) ---
    // FIX 4: Removed useCallback, no longer needed after removing shake effect
    const goToNextMobile = () => {
        setMobileActiveIndex(prev => (prev + 1) % vitals.length);
    };

    const goToPrevMobile = () => {
        setMobileActiveIndex(prev => (prev - 1 + vitals.length) % vitals.length);
    };

    const handleTouchStart = (e) => {
        setTouchStartX(e.targetTouches[0].clientX);
    };

    const handleTouchEnd = (e) => {
        const touchEndX = e.changedTouches[0].clientX;
        const distance = touchStartX - touchEndX;
        if (distance > minSwipeDistance) {
            goToNextMobile();
        } else if (distance < -minSwipeDistance) {
            goToPrevMobile();
        }
    };

    // FIX 4: Removed the entire useEffect for 'devicemotion' (shake feature).
    // It's unreliable, confusing for users, and requires permissions on many devices.
    // The swipe gesture is a better and more reliable interaction.


    return (
        <section ref={ref} className="bg-gray-50 py-20 relative overflow-hidden">
            <div className="absolute inset-0 z-0 opacity-20">
                <div 
                    className="absolute inset-0 bg-[linear-gradient(to_right,#e5e7eb_1px,transparent_1px),linear-gradient(to_bottom,#e5e7eb_1px,transparent_1px)] bg-[size:3rem_3rem]"
                    style={{ maskImage: 'radial-gradient(ellipse_at_center,transparent_20%,black)' }}
                ></div>
            </div>
            
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
                <div className="text-center mb-16">
                    <h2 className="text-3xl md:text-4xl font-extrabold text-gray-900">
                        A Higher Standard of Design
                    </h2>
                    <p className="mt-4 max-w-2xl mx-auto text-xl text-gray-600">
                        We create spaces that don't just look beautiful they feel right. Our commitment to quality, function, and your personal story means a better experience for you.
                    </p>
                </div>

                {/* --- DESKTOP: Interactive Clickable & Hoverable Fanned Cards --- */}
                <div 
                    className="hidden lg:flex justify-center items-center mt-20 h-[450px] relative perspective-1000 group"
                    onMouseEnter={() => setIsHovered(true)}
                    onMouseLeave={() => setIsHovered(false)}
                >
                    <button onClick={handlePrevDesktop} className={`absolute left-0 z-30 w-16 h-16 bg-white/50 rounded-full flex items-center justify-center shadow-lg transition-all duration-300 opacity-0 group-hover:opacity-100 hover:scale-110 hover:bg-white`}>
                        <i className="fas fa-chevron-left text-gray-700"></i>
                    </button>
                    <button onClick={handleNextDesktop} className={`absolute right-0 z-30 w-16 h-16 bg-white/50 rounded-full flex items-center justify-center shadow-lg transition-all duration-300 opacity-0 group-hover:opacity-100 hover:scale-110 hover:bg-white`}>
                        <i className="fas fa-chevron-right text-gray-700"></i>
                    </button>
                    
                    {vitals.map((vital, index) => {
                        const numItems = vitals.length;
                        let offset = index - activeIndex;
                        if (offset > numItems / 2) { offset -= numItems; }
                        if (offset < -numItems / 2) { offset += numItems; }

                        const isVisible = Math.abs(offset) <= 3;
                        let transform;

                        if (isHovered) {
                            transform = `rotate(${offset * 10}deg) translateX(${offset * 150}px) scale(${1 - Math.abs(offset) * 0.05})`;
                            if(offset === 0) {
                                transform += ` translateY(-1.5rem) scale(1.05)`; 
                            }
                        } else {
                            transform = `rotate(${offset * 3}deg) translateX(${offset * 20}px) translateY(${Math.abs(offset) * 10}px)`;
                        }

                        const style = { 
                            transform, 
                            zIndex: 10 - Math.abs(offset), 
                            opacity: isVisible ? 1 : 0, 
                            transition: 'all 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94)', 
                            willChange: 'transform'
                        };

                        return (
                            <div
                                key={vital.title}
                                className={`absolute transition-all duration-500 ease-in-out cursor-pointer ${inView ? 'opacity-100' : 'opacity-0'}`}
                                style={style}
                                // FIX 1: Removed redundant outer onClick. The VitalCard component handles it.
                            >
                                {/* * FIX 2: Changed onImageClick prop. 
                                  * Now, clicking a card sets it as active (centers it) AND opens the modal.
                                */}
                                <VitalCard 
                                    vital={vital} 
                                    onImageClick={() => { 
                                        handleCardClick(index); 
                                        handleImageClick(vital); 
                                    }} 
                                />
                            </div>
                        );
                    })}
                </div>

                {/* --- MOBILE: Looping, Swipeable, and Shakeable Stack --- */}
                <div className="lg:hidden mt-8">
                    <div className="relative h-[450px] w-full max-w-sm mx-auto">
                        {vitals.map((vital, index) => {
                            const numItems = vitals.length;
                            let offset = index - mobileActiveIndex;
                            if (offset > numItems / 2) { offset -= numItems; }
                            if (offset < -numItems / 2) { offset += numItems; }

                            const isVisibleStack = Math.abs(offset) <= 3;
                            let transform = '';
                            let opacity = 0;

                            if (offset === 0) {
                                transform = 'translateY(0) scale(1) rotate(0deg)';
                                opacity = 1;
                            } else if (isVisibleStack) {
                                transform = `translateX(${offset * 10}px) translateY(${Math.abs(offset) * 20}px) rotate(${offset * 3}deg) scale(${1 - Math.abs(offset) * 0.03})`;
                                opacity = 1;
                            } else {
                                opacity = 0;
                            }

                            const style = { 
                                transform, 
                                zIndex: vitals.length - Math.abs(offset), 
                                opacity, 
                                transition: 'all 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94)', 
                                willChange: 'transform'
                            };

                            return (
                                <div
                                    key={vital.title}
                                    className="absolute top-0 left-0 w-full h-full flex justify-center"
                                    style={style}
                                    onTouchStart={offset === 0 ? handleTouchStart : undefined}
                                    onTouchEnd={offset === 0 ? handleTouchEnd : undefined}
                                    // FIX 3: Removed redundant outer onClick. The VitalCard component handles it.
                                >
                                    <VitalCard vital={vital} onImageClick={handleImageClick} />
                                </div>
                            );
                        })}
                    </div>
                </div>
            </div>
            
            {/* --- RENDER THE MODAL --- */}
            <ImageModal image={selectedImage} onClose={handleCloseModal} />

            <style jsx>{`
                .perspective-1000 {
                  perspective: 1000px;
                }
              `}</style>
        </section>
    );
}

export default CoreVitalsSection;